import styled from 'styled-components'

export const LotDescriptionContainer = styled.div`
  margin-top: 2rem;
`

export const LotName = styled.h2`
  ${({ theme }) => theme.typography.heading.heading5}
`

export const LotDesc = styled.div`
  .LotDesc {
    word-wrap: break-word;
  }

  b {
    ${({ theme }) => theme.fontStyles.sourceSans.medium}
  }
`

export const DescriptionTitle = styled.h3`
  ${({ theme }) => theme.typography.heading.heading5}

  margin-top: 1rem;
`

export const ExtendedDescription = styled.div`
  p {
    ${({ theme }) => theme.fontStyles.sourceSans.regular}
    color: ${({ theme }) => theme.colours.primary.black};
    word-break: break-word;
    line-height: 26px;
  }

  b {
    ${({ theme }) => theme.fontStyles.sourceSans.bold}
  }
`
